import { GeneralAction } from '../../../../shared/infrastructure/store/actions/general_action';
import { UserActionType, UserActionType as actions } from '../actions/action';
import InitialUserState from '../state/state';
import UserState from '../state/state.interface';

const user = (state = InitialUserState, action: GeneralAction<UserActionType>) => {
    switch (action.type) {
        case actions.LOGGING_IN:
            return { ...state, loggingIn: true };
        case actions.LOGGING_IN_SUCCESS:
            return { ...state, loggingIn: false, loggingInSuccess: true };
        case actions.LOGGING_IN_FAILURE:
            return { ...state, loggingIn: false, loggingInSuccess: false, loggingInFailure: action.payload };
        case actions.VALIDATING_USER_EMAIL:
            return { ...state, validatingUserEmail: true };
        case actions.VALIDATING_USER_EMAIL_SUCCESS:
            return { ...state, validatingUserEmail: false, validatingUserEmailSuccess: true };
        case actions.VALIDATING_USER_EMAIL_FAILURE:
            return {
                ...state,
                validatingUserEmail: false,
                validatingUserEmailSuccess: false,
                validatingUserEmailFailure: action.payload
            };
        case actions.VALIDATING_PASSWORD:
            return { ...state, validationPassword: true } as UserState;
        case actions.IS_TEST_USER_PASSWORD_CORRECT:
            return { ...state, validationPassword: false, isTestUserPasswordCorrect: action.payload } as UserState;
        case actions.CREATING_PASSWORD:
            return { ...state, creatingPassword: true };
        case actions.CREATING_PASSWORD_SUCCESS:
            return { ...state, creatingPassword: false, creatingPasswordSuccess: action.payload } as UserState;
        case actions.CREATING_PASSWORD_FAILURE:
            return {
                ...state,
                creatingPassword: false,
                creatingPasswordSuccess: null,
                creatingPasswordFailure: action.payload
            } as UserState;
        case actions.RESEND_VERIFICATION:
            return {
                ...state,
                resendError: null,
                resendingVerification: true,
                resentVerification: false,
                resendVerificationSuccess: null
            };
        case actions.RESEND_VERIFICATION_FAILURE:
            return {
                ...state,
                resendError: action.payload,
                resendingVerification: false,
                resentVerification: false,
                resendVerificationSuccess: null
            };
        case actions.RESEND_VERIFICATION_SUCCESS:
            return {
                ...state,
                resendError: null,
                resendingVerification: false,
                resentVerification: true,
                resendVerificationSuccess: action.payload
            };
        case actions.REQUIRES_2FA:
            return { ...state, requires2FA: action.payload, loggingInFailure: '' };
        default:
            return state;
    }
};

export default user;
